import { Observable } from 'rxjs';

import { ModelPrepped } from 'app/type/model-prepped';

import { HttpOptions } from './http-options';
import { IdLike, RestfulApiService } from './restful-api.service';
import { SeamCompareResults } from '../model/request/seam-compare-results';
import { SeamRequest } from '../model/seam-request';

class SeamRequestService extends RestfulApiService<SeamRequest> {
    public transition(request: IdLike | SeamRequest, transition: string): Observable<SeamRequest> {
        return this.http.post<SeamRequest>(`${this.getAlterUrl(request)}/transition`, { transition });
    }

    public runStats(request: SeamRequest): Observable<void> {
        return this.http.post(`${this.getAlterUrl(request)}/run-stats`);
    }

    public compare(
        request: SeamRequest,
        otherRequest: SeamRequest,
        reRun: boolean,
        withLegacy: boolean,
    ): Observable<SeamCompareResults> {
        const opts: HttpOptions = {};
        opts.params = {
            reRun: reRun ? 1 : undefined,
            withLegacy: withLegacy ? 1 : undefined,
        };

        return this.http.get<SeamCompareResults>(`${this.getAlterUrl(request)}/compare/${otherRequest.id}`, opts);
    }

    protected getFormName(): string {
        return 'seam_workflow';
    }

    protected getPath(): string {
        return 'seam-workflows';
    }

    protected prepareSaveData(entity: SeamRequest): ModelPrepped<SeamRequest> {
        return {
            ...entity,
            crisRequest: entity.crisRequest.id,
            store: entity.store.id,
            owner: entity.owner?.id,
            manager: entity.manager?.id,
            tuner: entity.tuner?.id,
        };
    }
}

export const seamRequestService = new SeamRequestService();
